/**
 * How a channel is shown in pickers and lists: "Acme (+91 98765 43210)".
 * Two channels can share a business name, so the number is what identifies one.
 */
export function channelLabel(channel) {
    if (channel.type === 'WEBSITE')
        return `Website chat: ${channel.name}`;
    return channel.phoneNumber ? `${channel.name} (${channel.phoneNumber})` : channel.name;
}
//# sourceMappingURL=channels.js.map